import { useQuery } from "@tanstack/react-query";
import type { TicketsQueryParams, ApiSuccessResponse, MyPurchasedTicketsResponse } from "@/types/tickets";
import { getTickets, getMyPurchasedTickets } from "@/services/tickets";

export const useTickets = (params?: TicketsQueryParams) => {
  return useQuery<ApiSuccessResponse, unknown>({
    queryKey: ["categories", params],
    queryFn: () => getTickets(params),
  });
};

export function useMyPurchasedTickets(enabled = true) {
  return useQuery<MyPurchasedTicketsResponse>({
    queryKey: ["my-purchased-tickets"],
    queryFn: getMyPurchasedTickets,
    enabled,
    retry: false,
    staleTime: 1000 * 60 * 5,
  });
}
